let vkPromise = null

export const VK_MAPS_API_KEY = 'RS213ee1549d888d597e550cbff054eeb0dba404c73409f26ba7840e121988fb'

function ensureVkCss() {
  const existing = document.querySelector('link[data-vk-mmrgl-css="1"]')
  if (existing) return

  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = 'https://maps.vk.com/sdk/js/0.0/mmr-gl.css'
  link.setAttribute('data-vk-mmrgl-css', '1')
  document.head.appendChild(link)
}

export function loadVkMaps(apiKey = VK_MAPS_API_KEY) {
  if (vkPromise) return vkPromise

  vkPromise = new Promise((resolve, reject) => {
    if (window.mmrgl) {
      window.mmrgl.accessToken = apiKey
      return resolve(window.mmrgl)
    }

    ensureVkCss()

    const existingScript = document.querySelector('script[data-vk-mmrgl-js="1"]')
    if (existingScript) {
      const waitForSdk = setInterval(() => {
        if (window.mmrgl) {
          clearInterval(waitForSdk)
          window.mmrgl.accessToken = apiKey
          resolve(window.mmrgl)
        }
      }, 50)

      setTimeout(() => {
        clearInterval(waitForSdk)
        vkPromise = null
        reject(new Error('Timeout: VK Maps SDK did not initialize'))
      }, 12000)
      return
    }

    const script = document.createElement('script')
    script.src = 'https://maps.vk.com/sdk/js/0.0/mmr-gl.js'
    script.async = true
    script.setAttribute('data-vk-mmrgl-js', '1')

    const timeout = setTimeout(() => {
      vkPromise = null
      reject(new Error('Timeout: VK Maps SDK did not respond'))
    }, 12000)

    script.onload = () => {
      clearTimeout(timeout)
      if (!window.mmrgl) {
        vkPromise = null
        return reject(new Error('VK Maps SDK loaded but global mmrgl object is missing'))
      }
      window.mmrgl.accessToken = apiKey
      resolve(window.mmrgl)
    }

    script.onerror = () => {
      clearTimeout(timeout)
      vkPromise = null
      reject(new Error('Network error: failed to load VK Maps SDK'))
    }

    document.head.appendChild(script)
  })

  return vkPromise
}
